import getLocalString from "constants/Localization";
import {
  GetDailyFormVehicleTypesDocument,
  useCreateDailyFormVehicleTypeMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateDailyFormVehicleType() {
  const [mutation, { loading, data, error }] = useCreateDailyFormVehicleTypeMutation({
    refetchQueries: [
      {
        query: GetDailyFormVehicleTypesDocument,
        variables: {},
      },
    ],
  });

  const [createDailyFormVehicleType, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createDailyFormVehicleType",
    },
    {
      successMessage: getLocalString("fleet.create-vehicle-type-success"),
      failureMessage: getLocalString("fleet.create-vehicle-type-failure"),
    }
  );

  return [createDailyFormVehicleType, context] as const;
}
